import { config } from '../config';
import { handleResponse } from "../helpers/response";
import i18n from 'i18next';
import { clearItemComments } from "./wishCompareCart";

export const HIDE_ITEM_LOADER = 'HIDE_ITEM_LOADER';
export const PUT_ITEM_DATA = 'PUT_ITEM_DATA';
export const SHOW_ITEM_LOADER = 'SHOW_ITEM_LOADER';
export const ITEM_COMPARE_REMOVED_DATA = 'ITEM_COMPARE_REMOVED_DATA';
export const ITEM_COMPARE_ADDED_DATA = 'ITEM_COMPARE_ADDED_DATA';
export const FINDED_ITEM_DATA = 'FINDED_ITEM_DATA';
export const RECEIVED_ITEM_CART_DATA = 'RECEIVED_ITEM_CART_DATA';
export const ACTION_PLUS_CART_COUNT = 'ACTION_PLUS_CART_COUNT';
export const ACTION_MINUS_CART_COUNT = 'ACTION_MINUS_CART_COUNT';
export const CHANGE_COMMENT_ACTION = 'CHANGE_COMMENT_ACTION';
export const CLEAR_COUNT_ADD_TO_CART = 'CLEAR_COUNT_ADD_TO_CART';
export const ITEM_UPDATE_COUNT = 'ITEM_UPDATE_COUNT';

/**
 * Gets item data action
 *
 * @param category
 * @param id
 * @param locale
 * @returns {function(...[*]=)}
 */
export function getsItemData(category, id) {
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/catalog/" + category + "/item/" + id + "/" + i18n.language;
        dispatch(showLoader());
        fetch(link).then(handleResponse).then(json => {
            dispatch(setItemData(json));
            dispatch(hideLoader());
            dispatch(clearItemComments());
        });
    }
}

export function plusCartCount() {
    return {
        type: ACTION_PLUS_CART_COUNT
    }
}

export function minusCartCount() {
    return {
        type: ACTION_MINUS_CART_COUNT
    }
}

export function clearCountAddToCart() {
    return {
        type: CLEAR_COUNT_ADD_TO_CART
    }
}

export function updateItemCount(count) {
    return {
        type: ITEM_UPDATE_COUNT,
        count: count
    }
}

/**
 * Sets item data
 *
 * @param json
 * @returns {{item: *, type: string}}
 */
export function setItemData(data) {
    return {
        type: PUT_ITEM_DATA,
        item: data,
        showItemLoader: false
    }
}


/**
 * Shows loader
 *
 * @returns {{type: string, showItemLoader: boolean}}
 */
export function showLoader() {
    return {
        type: SHOW_ITEM_LOADER,
        showItemLoader: true
    }
}



/**
 * Add to compare
 *
 * @param id
 * @returns {function(...[*]=)}
 */
export function addToCompare(id) {
    return (dispatch, getState) => {
        var link = config.apiUrl + "api/comparision/add/";
        const formData = new FormData();
        dispatch(showLoader());
        formData.append("product_id", id);
        formData.append('tok_', getState().user.userInfo._tok);
        fetch(link, { method: 'POST', body: formData }).then(handleResponse).then(json => {
            dispatch(addedToCompare(id));
            dispatch(hideLoader());
        })
    }
}

export function removeFromCompare(id) {
    return (dispatch, getState) => {
        dispatch(showLoader());
        var link = config.apiUrl + "api/compare/remove/";
        const formData = new FormData();
        formData.append('good_id', id);
        formData.append('tok_', getState().user.userInfo._tok);
        fetch(link, { method: 'POST', body: formData }).then(handleResponse).then(json => {
            dispatch(removedFromCompare(id));
        });
    }
}





/**
 * Add to compare
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
export function addedToCompare(id) {
    return {
        type: ITEM_COMPARE_ADDED_DATA,
        id: id
    }
}

export function removedFromCompare(id) {
    return {
        type: ITEM_COMPARE_REMOVED_DATA,
        id: id
    }
}

/**
 *
 *
 * @returns {{type: string, showItemLoader: boolean}}
 */
export function hideLoader() {
    return {
        type: HIDE_ITEM_LOADER,
        showItemLoader: false
    }
}

/**
 * Changes select action
 *
 * @param filterId
 * @param itmId
 * @returns {function(...[*]=)}
 */
export function changeSelect(itmId, filterId, valueId, category) {
    return (dispatch, getState) => {
        dispatch(showLoader());
        // console.log("getState ", getState());
        var selectedFilters = [];
        if (getState().goodItem.triggeredObject.length) {
            getState().goodItem.triggeredObject.forEach((itm, inx) => {
                // don`t push previous if it was triggered again => has new values that not equal values in store
                if (itm.filterId !== filterId) {
                    selectedFilters.push(itm.filterId + "-" + itm.valueId);
                }
            })
        }
        selectedFilters.push(filterId + "-" + valueId);
        var link = config.apiUrl + "api/goods/item/find/" + i18n.language + "?id="
            + itmId +
            "&category=" + category +
            "&filter="
            + selectedFilters.join('+') +
            "&triggered_filter=" + filterId + "-" + valueId;
        fetch(link).then(handleResponse).then(json => {
            dispatch(setFindedData(json, Object.keys(json.filtersConvertedRequested).map((itm) => {
                return { 'filterId': itm, "valueId": json.filtersConvertedRequested[itm] }
            })));
            dispatch(hideLoader());
        });
    }
}

/**
 *
 * @param json
 * @param triggeredObject
 * @returns {{item: *, isFinded: boolean, type: string}}
 */
export function setFindedData(json, triggeredObject) {
    return {
        type: FINDED_ITEM_DATA,
        item: json,
        isFinded: true,
        isChangeUrl: true,
        urlForChange: '/products/' + i18n.language + '/' + json.goodItem.categories.alias + '/item/' + json.goodItem.id,
        triggeredObject: triggeredObject
    }
}